export const FETCH_EDUCATION_REQUEST = 'FETCH_EDUCATION_REQUEST';
export const FETCH_EDUCATION_SUCCESS = 'FETCH_EDUCATION_SUCCESS';
export const FETCH_EDUCATION_FAILURE = 'FETCH_EDUCATION_FAILURE';

export const CREATE_EDUCATION_REQUEST = 'CREATE_EDUCATION_REQUEST';
export const CREATE_EDUCATION_SUCCESS = 'CREATE_EDUCATION_SUCCESS';
export const CREATE_EDUCATION_FAIL = 'CREATE_EDUCATION_FAIL';
export const CREATE_EDUCATION_RESET = 'CREATE_EDUCATION_RESET';

export const DELETE_EDUCATION_REQUEST = 'DELETE_EDUCATION_REQUEST';
export const DELETE_EDUCATION_SUCCESS = 'DELETE_EDUCATION_SUCCESS';
export const DELETE_EDUCATION_FAIL = 'DELETE_EDUCATION_FAIL';
export const DELETE_EDUCATION_RESET = 'DELETE_EDUCATION_RESET';

export const UPDATE_EDUCATION_REQUEST = 'UPDATE_EDUCATION_REQUEST';
export const UPDATE_EDUCATION_SUCCESS = 'UPDATE_EDUCATION_SUCCESS';
export const UPDATE_EDUCATION_FAIL = 'UPDATE_EDUCATION_FAIL';
export const UPDATE_EDUCATION_RESET = 'UPDATE_EDUCATION_RESET';
